import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardText, CardFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import { isGoogleCalendarConnected, disconnectGoogleCalendar } from '../../axios/oauth/oauth';
import { useAuthStore } from '../../zustand-store/auth.store';
import LockedFeatureTooltip from './LockedFeatureTooltip';
import DeleteModal from './DeleteModal';

const GoogleCalendarOAuthCard = ({ title, description, icon }) => {
  const [isGoogleCalendarIntegrated, setIsGoogleCalendarntegarted] = useState(false);
  const [loader, setLoader] = useState(true);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const locationId = useAuthStore((state) => state.locationId);
  const businessId = useAuthStore((state) => state.businessId);
  const id = useAuthStore((state) => state.id);
  const currentPlan = useAuthStore((state) => state.currentPlan);
  const isLocked = currentPlan === 'Starter'; // 👈 condition for lock
  useEffect(() => {
    // Call the check function initially
    checkGoogleCalendarConnected();

    // Define the visibility handler
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        if (isGoogleCalendarIntegrated === false) {
          checkGoogleCalendarConnected();
        }
      } else {
        console.log('Tab is hidden');
      }
    };

    // Attach the event listener
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup function to remove the listener
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [locationId]);

  const checkGoogleCalendarConnected = async () => {
    let response = await isGoogleCalendarConnected(locationId, businessId);
    if (response.status === 200) {
      setIsGoogleCalendarntegarted(response?.data?.data);
      setLoader(false);
    }
  };

  const disconnect = async () => {
    setLoader(true);
    let response = await disconnectGoogleCalendar(locationId, businessId);
    if (response.status === 200) {
      setIsGoogleCalendarntegarted(false);
      setLoader(false);
      setDisconnectModalOpen(false);
    }
  };
  const handleCalendarAuth = () => {
    // const width = 600;
    // const height = 600;
    // const left = window.innerWidth / 2 - width / 2;
    // const top = window.innerHeight / 2 - height / 2;

    const authWindow = window.open(
      `${import.meta.env.VITE_BASE_URL_BACKEND}/google/oauth?locationId=${locationId}&businessId=${businessId}&userId=${id}`,
      'Google OAuth'
      // `width=${width},height=${height},top=${top},left=${left}`
    );

    if (!authWindow) {
      alert('Popup blocked. Please allow popups for this site.');
      return;
    }
  };

  return (
    <>
      <Card
        style={{ border: '1px solid', color: '#EFF2F7', cursor: 'pointer', height: 250 }}
        onClick={() => {
          if (!isGoogleCalendarIntegrated) {
            if (!isLocked) {
              handleCalendarAuth();
            }
            //   alert("Work in progress")
          }
        }}
        id="square-integration-card">
        <CardBody>
          <div className="d-flex justify-content-between">
            <img style={{ width: '30px', height: '30px' }} src={icon} alt="" />
            {loader ? (
              <span className="text-warning">Loading...</span>
            ) : (
              <>
                {isGoogleCalendarIntegrated ? (
                  <span
                    className="bg-success text-white"
                    style={{
                      fontSize: 13,
                      color: '#000',
                      background: '#F2F2F2',
                      padding: 6,
                      paddingRight: 16,
                      paddingLeft: 16,
                      borderRadius: 123
                    }}>
                    <i className="mdi mdi-check" style={{ paddingLeft: 10, paddingRight: 9 }} />{' '}
                    Connected
                  </span>
                ) : isLocked ? (
                  // 🔒 Locked state for Starter plan
                  <div id="lockTooltipTarget" className="d-flex align-items-center text-muted">
                    <LockedFeatureTooltip
                      id="googleCalendarLock"
                      value="Connect"
                      message={`You’re on the ${currentPlan} Plan. Upgrade to enable Google Calendar integration.`}
                    />
                  </div>
                ) : (
                  // Default (unlocked but not yet integrated)
                  <span className="text-primary">Connect</span>
                )}
              </>
            )}
          </div>
          <p style={{ fontSize: '13px', fontWeight: '700', color: '#000', marginTop: 14 }}>
            {title}
          </p>
          <CardText style={{ color: '#000', fontSize: '13px', fontWeight: '400', marginTop: 8 }}>
            {description}
          </CardText>
        </CardBody>
        <CardFooter
          style={{ minHeight: '48px' }} // set enough height for your content
          className="d-flex align-items-center justify-content-end py-2">
          {isGoogleCalendarIntegrated ? (
            loader ? (
              <span className="text-warning" style={{ fontSize: 13 }}>
                Loading...
              </span>
            ) : (
              <span
                className="text-danger"
                style={{ cursor: 'pointer', fontSize: 13 }}
                onClick={() => setDisconnectModalOpen(true)}>
                Disconnect
              </span>
            )
          ) : (
            // optional invisible placeholder to maintain structure
            <span className="invisible">Disconnect</span>
          )}
        </CardFooter>
      </Card>
      <DeleteModal
        show={disconnectModalOpen}
        isDeleting={loader}
        heading="Are you sure you want to disconnect Google Calendar? Your appointments will no longer sync with Google Calendar."
        componentName="Google Calendar"
        buttonTitle="Disconnect"
        onDeleteClick={disconnect}
        onCloseClick={() => setDisconnectModalOpen(false)}
      />
    </>
  );
};

GoogleCalendarOAuthCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  isIntegrated: PropTypes.string,
  icon: PropTypes.any, // replace 'any' with the actual prop type
  onClick: PropTypes.any,
  integartionFlag: PropTypes.any
};

export default GoogleCalendarOAuthCard;
